import GLU from '../glu2.js/src/index';

class DealListApi extends GLU.Api {
  constructor(endpoint) {
    super(endpoint);

    this.createApiActions(
      {
        name: 'getDealLists',
        method: GLU.Api.Get,
        path: '',
        credentials: true,
      },
    );
  }
}

export default DealListApi;
